import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationApi } from '@/Domain/api/Conversation/Conversation.api';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { UpdateVisitorRequest } from '@/Domain/api/Conversation/request/UpdateVisitor.request';

export const useUpdateVisitor = (conversationId: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [Endpoint.conversation.visitor, conversationId],
    mutationFn: (data: Partial<UpdateVisitorRequest>) =>
      ConversationApi.updateVisitor(data, conversationId),
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({ queryKey: ['conversations', {}] });
      void queryClient.setQueryData(
        [Endpoint.conversation.get, conversationId],
        (prevData: ConversationDto | undefined) =>
          prevData
            ? {
                ...prevData,
                [`visitor_${Object.keys(variables)[0]}`]: Object.values(variables)[0],
              }
            : prevData,
      );
    },
  });

  const handleUpdate = (data: Partial<UpdateVisitorRequest>) => mutation.mutate(data);

  return { handleUpdate };
};
